export const API = 'https://pcyc-api.appscore.digital/api/';
export const APP = 'https://pcyc-desktop.appscore.digital/';
export const MOBILE_APP = 'https://pcyc-mobile.appscore.digital';
export const DEPLOYED_VERSION='eda6c89fbff5092425818f407324a6f9baa58343'
